import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAccount, useConnect, useChainId } from 'wagmi';
import { Wallet } from 'lucide-react';
import { Button } from '@/shared/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/ui/card';

export function ConnectPage() {
  const navigate = useNavigate();
  const { isConnected } = useAccount();
  const chainId = useChainId();
  const { connect, connectors, isPending, error } = useConnect();

  // Redirect to dashboard if already connected
  useEffect(() => {
    if (isConnected) {
      navigate('/', { replace: true });
    }
  }, [isConnected, navigate]);

  return (
    <div className="min-h-screen bg-[#fdfcfb] flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          {/* Logo */}
          <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-to-br from-[#f26f56] to-[#f49756] flex items-center justify-center mb-4">
            <span className="text-white font-bold text-2xl">G</span>
          </div>
          <CardTitle className="text-2xl">GUBI Admin</CardTitle>
          <CardDescription>
            Connect your wallet to access the admin panel
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {connectors.map((connector) => (
            <Button
              key={connector.uid}
              onClick={() => connect({ connector })}
              disabled={isPending}
              className="w-full gap-2 h-12"
              variant={connector.id === 'injected' ? 'default' : 'outline'}
            >
              <Wallet className="w-5 h-5" />
              {isPending ? 'Connecting...' : `Connect with ${connector.name}`}
            </Button>
          ))}

          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-sm text-red-600">{error.message}</p>
            </div>
          )}

          <div className="pt-4 border-t border-gray-200">
            <p className="text-xs text-center text-[#807f7e]">
              Only authorized wallets can access this admin panel.
              <br />
              Contact the team if you need access.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
